<template>
	<div id="uniforms">
		Edit Uniforms
	</div>
</template>

<script>
import common from "@/common"

export default {
	name: "uniforms",
	data() {
		return {
			common: common,
		}
	},
	mounted() {
	}
}
</script>



// WEBPACK FOOTER //
// src/components/officer/uniforms.vue